const getDraftIncidentCategory = ({draft}: any) => {
  let incidentCategory
  const responses = JSON.parse(draft.session.responseStorage)

  switch (draft.type) {
    case "Verbal_Abuse":
      incidentCategory = responses?.security?.responses?.initiating_factor.replace('_', ' ') ?? null
      break;
    case "Antisocial_Behaviour":
      incidentCategory = responses?.security?.responses?.type_of_antisocial_behaviour.replace('_', ' ') ?? null
      break;
    default:
      incidentCategory = null
      break;
  }
  return incidentCategory
}

export default getDraftIncidentCategory